import {TrackableEntity} from './../data/ChangeTrackable';

export class AmsHts extends TrackableEntity {
    containerNo: string = '';
    id: number = 0;
    amsContainerId: number = 0;
    htsNo: string = '';
    description: string = '';
    marks: string = '';
    pkgs: number = 0;
    weight: number = 0;
    wUnit: string = '';
    value: number = 0;
    pUnit: string = '';
    country: string = '';
    amsHouseId: number = 0;
    volume: number = 0;
    vUnit: string = '';
    flagMarks: string = '';
    flagDesc: string = '';
    created: string = '';
    modified: string = '';

    constructor(init?:Partial<AmsHts>) {
        super();
        this.key='id';
        Object.assign(this, init);
        if(this.id === 0) this.id = this.GetNextId();
    }
}
